// extracted by mini-css-extract-plugin
export var titleAgenda = "summit-agenda-module--title-agenda--88230";
export var topPadding = "summit-agenda-module--top-padding--12694";